class ImageOverlay
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'image-overlay--bound'
            @.$closeButton = @.$el.querySelector '.image-overlay__closer'
            @.openCloseInterval = undefined
            @.closeDelay = 310
            @.openDelay = 160

            @.$el.classList.add 'image-overlay--bound'
            @.InitEvents()
            @.OpenImageOverlay()
        return

    InitEvents: ->
        self = @
        @.$closeButton.addEventListener 'click', (e) ->
            e.preventDefault()
            self.CloseImageOverlay()
            return
        return
    
    
    CloseImageOverlay: ->
        self = @
        window.clearInterval @.openCloseInterval
        @.$el.classList.remove 'image-overlay--open'
        @.openCloseInterval = window.setInterval ->
            window.clearInterval self.openCloseInterval
            self.$el.remove()
            return
        , @.closeDelay
        return

    OpenImageOverlay: ->
        self = @
        @.$el.classList.add 'image-overlay--appended'
        window.clearInterval @.openCloseInterval
        @.openCloseInterval = window.setInterval ->
            window.clearInterval self.openCloseInterval
            self.$el.classList.add 'image-overlay--open'
            return
        , @.openDelay
        return

BindImageOverlays = ->
    document.querySelectorAll '.image-overlay__content:not(.image-overlay--bound)'
        .forEach (el) ->
            new ImageOverlay el
            return
    return

window.addEventListener 'image-overlay-appended', BindImageOverlays
window.addEventListener 'bind-components', BindImageOverlays